$('.BurgerMenu').on('click', function () {
  $(this).toggleClass('BurgerMenu--active');
});

$('.js-close-cross-callback').on('click', function () {
  $('.CallBackBlock').removeClass('CallBackBlock--visible');
  $('.js-callback-btn').toggleClass('js-callback-btn--visible');
});

$('.js-close-cross').on('click', function () {
  $('.overlaY').removeClass('overlaY--visible');
  $('.js-estimate-btn').toggleClass('js-estimate-btn--visible');
});


$('.js-estimate-btn').on('click', function () {
  $('.EstimateBlock').toggleClass('EstimateBlock--visible');
  $('.js-estimate-btn').toggleClass('js-estimate-btn--visible');
  $('.overlaY').toggleClass('overlaY--visible');
});

// if ($(".EstimateBlock--visible").is(":visible")){alert ("#monelement est visible");}
// if ($(".EstimateBlock--visible").is(":hidden")){alert ("#monelement est caché"); }

$('.CustomCheckbox').on('change', function () {
  let $inputToFill = $(this).siblings('span').find('input');
  $inputToFill.val('');
  let $isChecked = $(this).attr('checked');
  if ($isChecked) {
    $inputToFill.val($(this).parent('label').data('text'));
  }
});



// WEBPACK FOOTER //
// ./scripts/presence/header.js